import React from 'react'
import { Link } from 'react-router-dom'

function AboutUs() {
  return (
    <>
    <section id="about" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-3xl font-bold mb-6">About Us</h3>
          <p className="text-gray-600 text-lg">
            We are a team dedicated to providing the best experience for our users. Our mission is to deliver quality and value in every interaction.
          </p>
        </div>
      </section>
      </>
  )
}

export default AboutUs
